import { render, staticRenderFns } from "./Interessen.vue?vue&type=template&id=66b1f842"
import script from "./Interessen.vue?vue&type=script&lang=js"
export * from "./Interessen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports